/**
 * Generated runtime TestId mirror for frontend/src/pages/CreateResource.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const CreateResourceTestIds = {
  btnCancelCreateResource: "btn-cancel-create-resource",
  btnSubmitCreateResource: "btn-submit-create-resource",
  cardTitleCreateResource: "card-title-create-resource",
  inputResourceDisplayName: "input-resource-display-name",
  inputResourceNativeKey: "input-resource-native-key",
  selectClassification: "select-classification",
  selectTargetSystem: "select-target-system",
  classification: (c_code: string) => `classification-${c_code}`,
  classificationPrefix: () => "classification-" as TestIdPrefix,
  system: (sys_id: string) => `system-${sys_id}`,
  systemPrefix: () => "system-" as TestIdPrefix
} as const;
